(function () {
  'use strict';

  var CB_NAME = 'custom#qual_o_seu_tipo_de_pele';
  var shadowObserver = null;
  var debounceTimer = null;

  var STYLES = [
    '.skin-type-multiselect{position:relative;width:100%;margin-top:8px;font-family:inherit;}',
    '.skin-trigger{display:flex;justify-content:space-between;align-items:center;',
      'border:1px solid rgba(0,0,0,0.3);border-radius:4px;padding:10px 14px;',
      'cursor:pointer;background:#fff;min-height:44px;font-size:14px;',
      'color:#999;user-select:none;box-sizing:border-box;}',
    '.skin-trigger:hover{border-color:rgba(0,0,0,0.6);}',
    '.skin-trigger.open{border-color:rgba(0,0,0,0.8);}',
    '.skin-trigger-text{flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin-right:8px;}',
    '.skin-trigger-text.filled{color:#1a1a1a;}',
    '.skin-arrow{display:flex;align-items:center;transition:transform 0.2s;flex-shrink:0;}',
    '.skin-arrow.open{transform:rotate(180deg);}',
    '.skin-panel{display:none;position:absolute;top:calc(100% + 4px);left:0;right:0;',
      'background:#fff;border:1px solid rgba(0,0,0,0.2);border-radius:4px;',
      'box-shadow:0 6px 20px rgba(0,0,0,0.12);z-index:99999;',
      'padding:6px 0;max-height:132px;overflow-y:auto;box-sizing:border-box;}',
    '.skin-panel.open{display:block;}',
    '.skin-item{display:flex;align-items:center;gap:10px;padding:10px 16px;',
      'cursor:pointer;font-size:14px;color:#1a1a1a;transition:background 0.1s;}',
    '.skin-item:hover{background:rgba(0,0,0,0.05);}',
    '.skin-check-box{width:18px;height:18px;flex-shrink:0;border-radius:3px;',
      'border:1.5px solid #ccc;display:flex;align-items:center;',
      'justify-content:center;transition:all 0.15s;background:#fff;}',
    '.skin-check-box.checked{background:#1a1a1a;border-color:#1a1a1a;}',
    '.skin-tick{display:none;}',
    '.skin-check-box.checked .skin-tick{display:flex;}',
  ].join('');

  function getShadowRoot() {
    var host = document.querySelector('shopify-forms-embed');
    return host && host.shadowRoot ? host.shadowRoot : null;
  }

  function prehide(shadow) {
    var cbs = shadow.querySelectorAll('input[type="checkbox"][name="' + CB_NAME + '"]');
    for (var i = 0; i < cbs.length; i++) {
      var w = cbs[i].closest('label') || cbs[i].parentElement;
      if (w) w.style.display = 'none';
    }
  }

  function scheduleTransform(shadow) {
    if (shadow) prehide(shadow);
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(tryTransform, 16);
  }

  function attachShadowObserver(shadow) {
    // If already watching this exact shadow root, nothing to do
    if (shadowObserver && shadowObserver._shadow === shadow) return;
    if (shadowObserver) shadowObserver.disconnect();
    shadowObserver = new MutationObserver(function () { scheduleTransform(shadow); });
    shadowObserver._shadow = shadow;
    shadowObserver.observe(shadow, { childList: true, subtree: true });
  }

  function tryTransform() {
    var shadow = getShadowRoot();
    if (!shadow) return;

    // Ensure observer is watching this shadow root
    attachShadowObserver(shadow);

    var checkboxes = shadow.querySelectorAll('input[type="checkbox"][name="' + CB_NAME + '"]');
    if (!checkboxes || checkboxes.length === 0) return;

    // Guard: already transformed in this render
    if (shadow.querySelector('.skin-type-multiselect')) return;

    // Disconnect before mutating to avoid self-triggering
    shadowObserver.disconnect();

    // Find fieldset container
    var container = checkboxes[0].closest('fieldset');
    if (!container) {
      var p = checkboxes[0].parentElement;
      for (var i = 0; i < 8; i++) {
        if (!p) break;
        if (p.querySelector('legend')) { container = p; break; }
        p = p.parentElement;
      }
    }
    if (!container) container = checkboxes[0].parentElement.parentElement;

    if (!container) {
      shadowObserver.observe(shadow, { childList: true, subtree: true });
      return;
    }

    // Inject styles once per shadow root lifetime
    if (!shadow.querySelector('style.skin-style')) {
      var style = document.createElement('style');
      style.className = 'skin-style';
      style.textContent = STYLES;
      shadow.appendChild(style);
    }

    // Collect options and hide original checkbox wrappers
    var options = [];
    for (var j = 0; j < checkboxes.length; j++) {
      var cb = checkboxes[j];
      options.push({ text: cb.getAttribute('aria-label') || cb.value, cb: cb });
      var wrapper = cb.closest('label') || cb.parentElement;
      if (wrapper) wrapper.style.display = 'none';
    }

    container.appendChild(buildWidget(options, shadow));

    // Reconnect after all mutations are done
    shadowObserver.observe(shadow, { childList: true, subtree: true });
  }

  function buildWidget(options, shadow) {
    var wrap = document.createElement('div');
    wrap.className = 'skin-type-multiselect';

    var trigger = document.createElement('div');
    trigger.className = 'skin-trigger';
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    var triggerText = document.createElement('span');
    triggerText.className = 'skin-trigger-text';
    triggerText.textContent = 'Selecione seu tipo de pele';

    var arrow = document.createElement('span');
    arrow.className = 'skin-arrow';
    arrow.innerHTML = '<svg width="12" height="8" viewBox="0 0 12 8" fill="none" aria-hidden="true">'
      + '<path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>'
      + '</svg>';

    trigger.appendChild(triggerText);
    trigger.appendChild(arrow);

    var panel = document.createElement('div');
    panel.className = 'skin-panel';
    panel.setAttribute('role', 'listbox');
    panel.setAttribute('aria-multiselectable', 'true');

    var selected = new Set();
    var isOpen = false;

    function updateTrigger() {
      if (selected.size === 0) {
        triggerText.textContent = 'Selecione seu tipo de pele';
        triggerText.classList.remove('filled');
      } else {
        triggerText.textContent = Array.from(selected).join(', ');
        triggerText.classList.add('filled');
      }
    }

    function openPanel() {
      isOpen = true;
      panel.classList.add('open');
      arrow.classList.add('open');
      trigger.classList.add('open');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function closePanel() {
      isOpen = false;
      panel.classList.remove('open');
      arrow.classList.remove('open');
      trigger.classList.remove('open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    options.forEach(function (opt) {
      var item = document.createElement('div');
      item.className = 'skin-item';
      item.setAttribute('role', 'option');
      item.setAttribute('aria-selected', 'false');

      var box = document.createElement('span');
      box.className = 'skin-check-box';

      var tick = document.createElement('span');
      tick.className = 'skin-tick';
      tick.innerHTML = '<svg width="11" height="8" viewBox="0 0 11 8" fill="none" aria-hidden="true">'
        + '<path d="M1 4L4 7L10 1" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>'
        + '</svg>';
      box.appendChild(tick);

      var lbl = document.createElement('span');
      lbl.textContent = opt.text;

      item.appendChild(box);
      item.appendChild(lbl);

      item.addEventListener('click', function (e) {
        e.stopPropagation();
        if (selected.has(opt.text)) {
          selected.delete(opt.text);
          opt.cb.checked = false;
          box.classList.remove('checked');
          item.setAttribute('aria-selected', 'false');
        } else {
          selected.add(opt.text);
          opt.cb.checked = true;
          box.classList.add('checked');
          item.setAttribute('aria-selected', 'true');
        }
        opt.cb.dispatchEvent(new Event('change', { bubbles: true }));
        updateTrigger();
      });

      panel.appendChild(item);
    });

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      isOpen ? closePanel() : openPanel();
    });

    shadow.addEventListener('click', function (e) {
      if (isOpen && !wrap.contains(e.target)) closePanel();
    });

    document.addEventListener('click', function () {
      if (isOpen) closePanel();
    });

    wrap.appendChild(trigger);
    wrap.appendChild(panel);
    return wrap;
  }

  var outerObserver = new MutationObserver(function () {
    var s = getShadowRoot();
    if (s) scheduleTransform(s);
  });
  outerObserver.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryTransform);
  } else {
    tryTransform();
  }
})();
